import React, { useState, forwardRef } from "react";
// We neeed to use this deprecated module for now until expo fixes release channels
import { StyleSheet, Keyboard } from "react-native";
import { Picker } from '@react-native-picker/picker';
import { TextInput } from "../../components";
import { useTheme, Modal, Portal } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
import { IDropdownProps } from "./dropdown";
import moment from "moment";
import { testProps } from "../../utils/testProps";

const DEFAULT_VALUE = "default";

export const MonthYearDropdown = forwardRef((props: IDropdownProps, ref: any) => {
  const { formName, setValue, errors, inputAccessoryViewID, onFocus, onSubmitEditing } = props;
  const { spacing, colors } = useTheme() as ThemeType;
  const [selectedMonth, setSelectedMonth] = useState(DEFAULT_VALUE);
  const [selectedYear, setSelectedYear] = useState(DEFAULT_VALUE);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isPickerVisible, setPickerVisible] = useState(false);
  const isYearSelected = selectedYear !== DEFAULT_VALUE;
  const isMonthSelected = selectedMonth !== DEFAULT_VALUE;

  const onSelectMonthHandler = (monthValue: any) => {
    if (monthValue === DEFAULT_VALUE) return;
    const date = moment();
    const year = isYearSelected ? selectedYear : date.year();
    date.month(monthValue);
    date.year(year);
    setValue(formName, date);
    setSelectedMonth(monthValue);
    setSelectedDate(date);
    if (!isYearSelected) {
      setSelectedYear(year.toString());
    }
  };

  const onSelectYearHandler = (yearValue: any) => {
    if (yearValue === DEFAULT_VALUE) return;
    const date = moment();
    const month = isMonthSelected ? selectedMonth : date.month();
    date.year(yearValue);
    date.month(month);
    setValue(formName, date);
    setSelectedYear(yearValue);
    setSelectedDate(date);
    if (!isMonthSelected) {
      setSelectedMonth(month);
    }
  };

  const onFocusHandler = () => {
    onFocus();
    setPickerVisible(true);
    Keyboard.dismiss();
  };

  const styles = StyleSheet.create({
    modalContainer: {
      display: "flex",
      marginHorizontal: spacing.medium,
      backgroundColor: colors.background,
      borderRadius: 10,
      flexDirection: "row",
      justifyContent: "center",
    },
    picker: { 
      width: "50%",
      padding: 15,
    },
    textInput: {},
  });

  const months = Array.from(new Array(12)).map((v, index) => ({ value: index, key: index }));
  const years = Array.from(new Array(30)).map((v, index) => ({
    value: String(2020 + index),
    key: index,
  }));

  const formattedDate = selectedDate ? selectedDate.format("MMM YYYY") : null;

  return (
    <>
      <Portal>
        <Modal
          visible={isPickerVisible}
          onDismiss={() => setPickerVisible(false)}
          contentContainerStyle={styles.modalContainer}>
          <Picker
            selectedValue={selectedMonth}
            style={styles.picker}
            onValueChange={onSelectMonthHandler}>
            <Picker.Item value={DEFAULT_VALUE} label="Select month..." />
            {months.map(({ value }, index) => {
              return <Picker.Item key={index} value={value} label={getMonthLabel(value)} />;
            })}
          </Picker>
          <Picker
            selectedValue={selectedYear}
            style={styles.picker}
            onValueChange={onSelectYearHandler}>
            <Picker.Item value={DEFAULT_VALUE} label="Select year..." />
            {years.map(({ value }, index) => {
              return <Picker.Item key={index} value={value} label={value} />;
            })}
          </Picker>
        </Modal>
      </Portal>
      <TextInput
        style={styles.textInput}
        value={formattedDate}
        iconName="calendar-blank-outline"
        error={errors?.[formName]?.message}
        mode="outlined"
        onFocus={onFocusHandler}
        inputAccessoryViewID={inputAccessoryViewID}
        onSubmitEditing={onSubmitEditing}
        ref={ref}
        {...testProps(formName)}
      />
    </>
  );
});

const getMonthLabel = (monthNum: number) => {
  const date = moment();
  date.month(monthNum);
  return date.format("M MMM");
};
